import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-inputs-chip-modal',
  templateUrl: './inputs-chip-modal.component.html',
  styleUrls: ['./inputs-chip-modal.component.scss']
})
export class InputsChipModalComponent implements OnInit {

  form: UntypedFormGroup;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  removable = true;
  selectable = true;
  excludedKeys = ['\\', '/', ':', '*', '?', '\"', '<', '>', '|' ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<InputsChipModalComponent>,
    private formBuilder: UntypedFormBuilder,
  ) { 
    console.log(this.data);
    this.form = this.formBuilder.group({
      myControl: ['']
    });
    this.form.get('myControl').setValue(this.data.currentValue);
  }

  ngOnInit(): void {
  }

  onClose(){
    this.dialogRef.close(this.form.get('myControl').value);
  }

   //#region Mat-chip

   addKeywordFromInput(event: MatChipInputEvent) {
    if (!event.value) return;
    if (this.checkExcludedCharacters(event.value, this.excludedKeys)) {
      event.chipInput!.clear(); 
      return;
    }
    const newValue = this.form.get('myControl');
    
    if(event.value.split('').length < 1025){
      newValue.setValue([...newValue.value, event.value]);
      event.chipInput!.clear();
    }
  }

  removeKeyword(keyword: string) {
    const newValue = this.form.get('myControl');
    newValue.setValue(newValue.value.filter(t => t != keyword));
  }

  checkExcludedCharacters(value: string, keywordsExcluded: string[]): boolean {
    return keywordsExcluded.some(key => value.includes(key));
  }

  //#endregion Mat-chip

}
